import React, { useContext, useEffect, useRef, useState } from "react";
import ThemeContext from "../../../utils/Contexts/ThemeContext";
import Constant from "../../Constants";
import LanguageContext from "../../../utils/Contexts/LanguageContext";
import RightArrow from "../../svg/RightArrow";
import _ from "lodash";
import axiosInstance from "../../../utils/Requests/axios";
import toast from "react-hot-toast";

function NewsAnnouncement() {
  const { t } = useContext(LanguageContext);
  const { themeStatus } = Constant();
  const { selectedTheme } = useContext(ThemeContext);

  const [announcementData, setAnnouncementData] = useState(null);
  const announcementPayload = {
    length: 5,
    columns: [{ data: "created" }],
    order: [{ column: 0, dir: "desc" }],
    search: {
      filters: [
        { key: "TYPE", value: 100 },
        { key: "CATEGORY", value: "ANNOUNCEMENT" },
      ],
    },
  };

  const announcementsFetched = useRef(false);

  const fetchAnnouncements = () => {
    if (announcementsFetched.current) return;
    announcementsFetched.current = true;
    const payload = _.cloneDeep(announcementPayload);
    const url = `projects/backlinksfactory/articles/search`;
    axiosInstance
      .post(url, payload)
      .then((response) => {
        setAnnouncementData(response?.data?.data);
      })
      .catch(() => {
        toast.error(t("There was an error fetching backlinks offers"));
      });
  };

  const [page, setPage] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const isFetching = useRef(false);
  const fetchAnnouncementsOnscroll = (pageNum = 0) => {
    if (isFetching.current || !hasMore) return;
    isFetching.current = true;

    const payload = _.cloneDeep(announcementPayload);
    payload.start = pageNum * payload.length;
    const url = `projects/backlinksfactory/articles/search`;

    axiosInstance
      .post(url, payload)
      .then((response) => {
        const newItems = response?.data?.data || [];
        setPage(pageNum);
        setHasMore(newItems.length === payload.length);
      })
      .catch(() => {
        toast.error(t("There was an error fetching backlinks offers"));
      })
      .finally(() => {
        isFetching.current = false;
      });
  };

  useEffect(() => {
    const container = document.querySelector(".articles-tab");
    if (!container) return;

    const handleScroll = () => {
      if (
        container.scrollTop + container.clientHeight >=
        container.scrollHeight - 50
      ) {
        fetchAnnouncementsOnscroll(page + 1);
      }
    };

    container.addEventListener("scroll", handleScroll);
    return () => container.removeEventListener("scroll", handleScroll);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, hasMore]);

  useEffect(() => {
    fetchAnnouncements();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const containerRef = useRef(null);
  const [hasScroll, setHasScroll] = useState(false);

  useEffect(() => {
    const el = containerRef.current;
    if (el && el.scrollHeight > el.clientHeight) {
      setHasScroll(true);
    }
  }, []);

  return (
    <div
      className={`w-100 pt-3 rounded dashboard-news-height cardSetting ${themeStatus?.[selectedTheme]}`}
      style={{ backgroundColor: "var(--bg-card)" }}
    >
      <div
        className="d-flex justify-content-between align-items-center px-3"
        style={{ paddingBlock: "0.4rem" }}
      >
        <h4
          className="dashboard-title-responsive p-0 mb-0"
          style={{ lineHeight: "150%" }}
        >
          {t("News and Announcements")}
        </h4>
        <p
          className="card-text cursor-pointer d-flex align-items-center gap-1 see-more-news"
          //   onClick={() => navigateToCards()}
        >
          {t("See More")} <RightArrow />
        </p>
      </div>
      <div className="px-3">
        <div
          className="my-3"
          style={{
            borderBottom: `2px solid var(--border)`,
            marginLeft: "-18px",
            marginRight: "-18px",
          }}
        ></div>
      </div>

      <div
        ref={containerRef}
        className={`d-flex flex-column articles-tab ${
          hasScroll ? "px-3" : "px-2"
        } custom-scroll `}
        style={{
          height: "calc(100% - 70px)",
          marginRight: hasScroll ? "8.8px" : "0px",
        }}
      >
        {!!announcementData?.length &&
          announcementData?.map((article, id) => (
            <div
              key={id}
              className="mb-2 d-block"
              style={{
                background: "var(--apex-tooltip)",
                border: "var(--apex-border)",
                boxShadow: "var(--apex-box-shadow)",
                borderRadius: "10px",
              }}
            >
              <div className="d-flex align-items-center px-3  news-announcement-tabs">
                <div className="d-flex flex-column gap-2">
                  <p
                    className="card-text p-0 m-0 pe-2"
                    style={{ color: "var(--whiteToBlack)", opacity: "60%" }}
                  >
                    {article?.title}
                  </p>
                  <p
                    className="p-0 m-0 pe-3"
                    style={{
                      fontSize: "14px",
                      fontWeight: "400",
                      color: "#6C747A",
                    }}
                  >
                    {article?.excerpt}
                  </p>
                </div>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
}

export default NewsAnnouncement;
